import DomUtils from './../utils/dom-utils';

const Cmi = {
    init() {
        let cmi_elements = document.querySelectorAll('.ca-minteresse');
        if (cmi_elements.length > 0) {
            [].forEach.call(cmi_elements, function (element) {
                let btn = element.querySelector('.btn');
                btn.addEventListener('click', function (event) {
                    event.preventDefault();
                    // console.log(event.currentTarget);
                    element.classList.toggle('open');
                });

                document.addEventListener('click', function (event) {
                    let parent = DomUtils.getClosest(event.target, '.ca-minteresse');
                    if (parent == false) {
                        element.classList.remove('open');
                    }
                })
            })
        }
    }
}

/* var getClosest = function (elem, selector) {

    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function (s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) { }
                return i > -1;
            };
    }

    // Get the closest matching element
    for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem;
    }
    return false;
}; */

export default Cmi;